export default {"src":"/_next/static/media/emptyGraph_barsThick.3d52ad6e.svg","height":78,"width":363,"blurWidth":0,"blurHeight":0};